import { Grid, TextField, Button } from '@material-ui/core';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import { useContext } from 'react';
import { distributorsContext } from '../DistributorsContext';


let Filters = () => {
    let service = useContext(distributorsContext);


    return (
        <form onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label='Name'
                        value={service.search.searchText}
                        onChange={(e) => service.updateSearch({ ...service.search, searchText: e.target.value })}
                    />
                </Grid>
                <Grid item>
                    <Button type="submit" variant="contained" onClick={service.doSearch}>
                        <SearchIcon />
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default Filters;